import { render, staticRenderFns } from "./general.vue?vue&type=template&id=dd4c8d38&scoped=true&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"
import style0 from "./general.vue?vue&type=style&index=0&id=dd4c8d38&scoped=true&lang=css&"
import style1 from "./general.vue?vue&type=style&index=1&id=dd4c8d38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4c8d38",
  null
  
)

export default component.exports